export function SepticPermits(params) {
    return `<table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
              <tr>
                  <th class="third">Address</th>
                  <td class="two-third">{Address}</td>
              </tr>
              <tr>
                  <th class="third">Type</th>
                  <td class="two-third">{Type}</td>
              </tr>
              <tr>
                  <th class="third">Image</th>
                  <td class="two-third">
                      <a target="_blank" href="{Image}" class="ui fluid tiny button">View Image</a>
                  </td>
              </tr>
          </tbody>
      </table>`;
  }
  